import { Autocomplete, TextField } from "@mui/material";
import { useController } from "react-hook-form";
import useCustomDataSource from "../../useCustomDataSource";

const CustomPrimaryKeyField = ({ field, control }) => {
  const { field: fieldProps, fieldState } = useController({
    control,
    name: field.name,
  });
  const { useOne } = useCustomDataSource(field.subModel);

  let choices = field.choices;

  const { data } = useOne(fieldProps.value, {
    enabled: !choices,
  });

  choices =
    field.choices ||
    (data ? [{ value: data.id, label: data._title, obj: data }] : undefined);

  if (choices) {
    return (
      <Autocomplete
        {...fieldProps}
        value={choices.find((opt) => fieldProps.value === opt.value) || null}
        onChange={(_, newValue) => {
          fieldProps.onChange(newValue.value);
        }}
        options={choices}
        getOptionLabel={(option) => option.label}
        renderInput={(params) => (
          <TextField
            {...params}
            label={field.label}
            helperText={fieldState.error?.message || field.help_text || ""}
            error={!!fieldState.error}
          />
        )}
        disabled={field.disabled}
        sx={{ display: field.hidden ? "none" : "block" }}
      />
    );
  }

  return (
    <TextField
      name={field.name}
      label={field.label}
      variant="outlined"
      fullWidth
      type={"text"}
      helperText={fieldState.error?.message || field.help_text || ""}
      disabled={field.disabled}
      sx={{ display: field.hidden ? "none" : "block" }}
      error={!!fieldState.error}
      {...fieldProps}
      value={fieldProps.value || ""}
    />
  );
};

export default CustomPrimaryKeyField;
